import { render, staticRenderFns } from "./DeclinedPage.vue?vue&type=template&id=7491e39a&"
import script from "./DeclinedPage.vue?vue&type=script&lang=js&"
export * from "./DeclinedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports